import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { AccessoryConfigListWidgetComponent } from '../accessory-config-list-widget/accessory-config-list-widget.component';

@Component({
  selector: 'app-formly-accessory-config-list-widget',
  templateUrl: './formly-accessory-config-list-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AccessoryConfigListWidgetComponent,
  ]
})
export class FormlyAccessoryConfigListWidgetComponent extends FieldType {

  productId: string;

  constructor(
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }


  ngOnInit(): void {

    // this.getProductId();
    // this.formControl?.valueChanges.subscribe(x => {
    //   this.getProductId();
    // });
  }

}